import { getWebinar, linkHelper } from '@app/utils'

export const getServerSideProps = async (context) => {
  var { params, query } = context;
  let id = query?.id ||'';
  let data = {};
  try {
    const result = await getWebinar(id)
    if (!result || result?.status !==200) {
      return {
        notFound: true,
      }
    }
    data = result.data;
  } catch(err) {
    console.error(err)
  }
  return {
    redirect:{
      destination: data.redirectUrl || linkHelper('webinar'),
      permanent: false
    }
  }
}

export default function Event() {
  return (
    <></>
  )
}